import React, { useEffect, useState } from "react";
import AllPubCoursesComp from "../../../../../../Components/AllCourseComp";
import { CousreTableHeading, UnPubCousreTableHeading } from "../../Constants/constant";
import {
  getAllPublishedCourseApi,
  updateUnpublishCourseApi,
  updatePublishCourseApi,
} from "../../Constants/api";
import { useHistory } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import AllUnPubCoursesComp from "../../../../../../Components/AllCourseUnPubComp";

const AllCourses = () => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [publishedCourse, setPublishedCourse] = useState("");
  const [unpublishedCourse, setUnpublishedCourse] = useState("");
  const [publishPage, setPublishPage] = useState({
    currentPage: 1,
    totalSize: 10,
  });

  const { currentPage, totalSize } = publishPage;
  const [unpublishPage, setUnpublishPage] = useState({
    unpublishPageCurrentPage: 1,
    unpublishPageTotalSize: 10,
  });

  const { unpublishPageCurrentPage, unpublishPageTotalSize } = unpublishPage;

  const [publishID, setPublishID] = useState("");
  const [showUnPublishAlert, setShowUnPublishAlert] = useState(false);
  const [showPublishAlert, setShowPublishAlert] = useState(false);
  const [showUnPublishConfirm, setShowUnPublishConfirm] = useState(false);
  const [showPublishConfirm, setShowPublishConfirm] = useState(false);

  const getAllPublishedCourseData = async (params) => {
    try {
      setIsLoading(true);
      const { data } = await getAllPublishedCourseApi(params);
      setPublishedCourse(data?.data);
      setPublishPage({
        currentPage: params?.page,
        totalSize: data?.count,
      });
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const getAllUnPublishedCourseData = async (params) => {
    try {
      setIsLoading(true);
      const { data } = await getAllPublishedCourseApi(params);
      setUnpublishedCourse(data?.data);
      setUnpublishPage({
        unpublishPageCurrentPage: params?.page,
        unpublishPageTotalSize: data?.count,
      });
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const handleTablePageChange = (type, { page, sizePerPage }) => {
    getAllPublishedCourseData({ pubType:true, page, limit: sizePerPage });
    setPublishPage({
      ...publishPage,
      currentPage: page,
    });
  };

  const handleTablePageChangeUnpublish = (type, { page, sizePerPage }) => {
    console.log(page, sizePerPage,'fjhfjhfhfjh');
    getAllUnPublishedCourseData({ pubType:false,page, limit: sizePerPage });
    setUnpublishPage({
      ...unpublishPage,
      unpublishPageCurrentPage: page,
    });
  };

  const handlePublishCourseClick = async (id) => {
    setPublishID(id);
    setShowUnPublishAlert(true);
  };

  const handleUnPublishCourseClick = async (id) => {
    setPublishID(id);
    setShowPublishAlert(true);
  };

  const publishCourseAction = async () => {
    await updateUnpublishCourseApi(publishID);
    setShowUnPublishAlert(false);
    setShowUnPublishConfirm(true);
    const filteredSeries = publishedCourse.filter(
      ({ _id }) => _id !== publishID
    );
    setPublishedCourse(filteredSeries);
    setPublishID("");
  };

  const UnPublishCourseAction = async () => {
    await updatePublishCourseApi(publishID);
    setShowPublishAlert(false);
    setShowPublishConfirm(true);
    const filteredSeries = unpublishedCourse.filter(
      ({ _id }) => _id !== publishID
    );
    setUnpublishedCourse(filteredSeries);
    setPublishID("");
  };

  const handleEditSeries = (id) => {
    history.push("/dashboard/courses/edit/" + id);
  };

  useEffect(() => {
    getAllPublishedCourseData({pubType:true ,page: 1, limit: 10 });
    getAllUnPublishedCourseData({pubType:false, page: 1, limit: 10 });
  }, []);

  return (
    <>
      <AllPubCoursesComp
        tableData={publishedCourse}
        tableHeading={CousreTableHeading}
        handleTablePageChange={handleTablePageChange}
        handlePublishCourseClick={handlePublishCourseClick}
        isLoading={isLoading}
        page={currentPage}
        sizePerPage={10}
        totalSize={totalSize}
        handleEditSeries={handleEditSeries}
      />

      <AllUnPubCoursesComp
       tableData={unpublishedCourse}
       tableHeading={UnPubCousreTableHeading}
       handleTablePageChange={handleTablePageChangeUnpublish}
       handlePublishCourseClick={handleUnPublishCourseClick}
       isLoading={isLoading}
       page={unpublishPageCurrentPage}
       sizePerPage={10}
       totalSize={unpublishPageTotalSize}
       handleEditSeries={handleEditSeries}
      />

      {showUnPublishAlert ? (
        <SweetAlert
          title="Are you sure?"
          warning
          showCancel
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, Unpublish it!"
          reverseButtons={true}
          onConfirm={publishCourseAction}
          onCancel={() => setShowUnPublishAlert(false)}
        ></SweetAlert>
      ) : null}

      {showUnPublishConfirm ? (
        <SweetAlert
          success
          title="Unpublished!"
          confirmBtnBsStyle="primary"
          onConfirm={() => {
            setShowUnPublishAlert(false);
            setShowUnPublishConfirm(false);
            window.location.reload();
          }}
        >
          Courses has been unpublished
        </SweetAlert>
      ) : null}

      {showPublishAlert ? (
        <SweetAlert
          title="Are you sure?"
          warning
          showCancel
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes,publish it!"
          reverseButtons={true}
          onConfirm={UnPublishCourseAction}
          onCancel={() => setShowPublishAlert(false)}
        ></SweetAlert>
      ) : null}

      {showPublishConfirm ? (
        <SweetAlert
          success
          title="published!"
          confirmBtnBsStyle="primary"
          onConfirm={() => {
            setShowUnPublishAlert(false);
            setShowUnPublishConfirm(false);
            window.location.reload();
          }}
        >
          Courses has been published
        </SweetAlert>
      ) : null}
    </>
  );
};

export default AllCourses;
